import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Scripture from '../components/Scripture.vue'
import Subject from '../components/Subject.vue'
import Book from '../components/Book.vue'
import AVMedia from '../components/AVMedia.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '书籍',
    component: Book
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
